var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 0.875C9.01119 0.875 9.29102 1.15482 9.29102 1.5V4.83333C9.29102 4.88859 9.31297 4.94158 9.35204 4.98065C9.39111 5.01972 9.4441 5.04167 9.49935 5.04167H12.8327C13.1779 5.04167 13.4577 5.32149 13.4577 5.66667C13.4577 6.01184 13.1779 6.29167 12.8327 6.29167H9.49935C9.11257 6.29167 8.74164 6.13802 8.46815 5.86453C8.19466 5.59104 8.04102 5.22011 8.04102 4.83333V1.5C8.04102 1.15482 8.32084 0.875 8.66602 0.875Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83268 2.125C2.55642 2.125 2.29146 2.23475 2.09611 2.4301C1.90076 2.62545 1.79102 2.8904 1.79102 3.16667V14.8333C1.79102 15.1096 1.90076 15.3746 2.09611 15.5699C2.29146 15.7653 2.55642 15.875 2.83268 15.875H11.166C11.4423 15.875 11.7072 15.7653 11.9026 15.5699C12.0979 15.3746 12.2077 15.1096 12.2077 14.8333V5.92555L8.40713 2.125H2.83268ZM1.21223 1.54621C1.642 1.11644 2.22489 0.875 2.83268 0.875H8.66602C8.83178 0.875 8.99075 0.940848 9.10796 1.05806L13.2746 5.22472C13.3918 5.34193 13.4577 5.50091 13.4577 5.66667V14.8333C13.4577 15.4411 13.2162 16.024 12.7865 16.4538C12.3567 16.8836 11.7738 17.125 11.166 17.125H2.83268C2.22489 17.125 1.642 16.8836 1.21223 16.4538C0.782458 16.024 0.541016 15.4411 0.541016 14.8333V3.16667C0.541016 2.55888 0.782458 1.97598 1.21223 1.54621Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99935 13.7917C6.65417 13.7917 6.37435 13.5118 6.37435 13.1667L6.37435 8.16667C6.37435 7.82149 6.65417 7.54167 6.99935 7.54167C7.34453 7.54167 7.62435 7.82149 7.62435 8.16667L7.62435 13.1667C7.62435 13.5118 7.34453 13.7917 6.99935 13.7917Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94129 11.1086C9.69721 11.3527 9.30149 11.3527 9.05741 11.1086L6.99935 9.05055L4.94129 11.1086C4.69721 11.3527 4.30149 11.3527 4.05741 11.1086C3.81333 10.8645 3.81333 10.4688 4.05741 10.2247L6.55741 7.72472C6.80149 7.48065 7.19721 7.48065 7.44129 7.72472L9.94129 10.2247C10.1854 10.4688 10.1854 10.8645 9.94129 11.1086Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.9c3d0b704544028ec4b2e88423556d2a.svg";
export { ForwardRef as ReactComponent };